<template>
  <BModal
    id="temperature-modal"
    ref="modal"
    centered
    hide-header
    hide-footer
    modal-class="modal-temperature modal-no-header-no-footer"
  >
    <div>
        <button type="button" data-dismiss="modal" aria-label="Close" class="close" @click="hide">
            <span aria-hidden="true">
                <img src="/build/icons/close@gray.svg" width="16" height="16" class="close-icon">
            </span>
        </button>
      <label class="title">{{ __('Qual o status de probabilidade do negócio?') }}</label>
      <div class="buttons-container">
        <a 
          href="#" 
          data-ignore-unsaved-check
          class="button-hot-modal"
          :class="{ active: isHotActive }"
          @click.prevent="toggleTemperature('hot')"
        >
          <img src="/build/icons/hot-icon-gray.svg" />
          <label class="label-hot-modal label-temperature">
            {{ __('Quente') }}
          </label>
        </a>
        <a 
          href="#" 
          data-ignore-unsaved-check
          class="button-warm-modal"
          :class="{ active: isWarmActive }"
          @click.prevent="toggleTemperature('warm')"
        >
          <img src="/build/icons/warm-icon-gray.svg" />
          <label class="label-warm-modal label-temperature">
            {{ __('Morno') }}
          </label>
        </a>
        <a 
          href="#" 
          data-ignore-unsaved-check
          class="button-cold-modal"
          :class="{ active: isColdActive }"
          @click.prevent="toggleTemperature('cold')"
        >
          <img src="/build/icons/cold-icon-gray.svg" />
          <label class="label-cold-modal label-temperature">
            {{ __('Frio') }}
          </label>
        </a>
        <button
            class="salesflow-btn salesflow-btn-primary"
            type="button"
            @click="saveTemperature"
            :disabled="!activeTemperature"
        >
            {{ __('Salvar') }}
        </button>
      </div>
    </div>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import axios from 'axios'

export default {
  name: 'TemperatureModal',
  
  components: {
    BModal
  },

  props: {
    dealId: {
      type: [Number, String],
      required: true
    },
    initialTemperature: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      activeTemperature: null
    }
  },

  watch: {
    initialTemperature: {
      immediate: true,
      handler(value) {
        if (typeof value === 'string') {
          this.activeTemperature = value;
          return;
        }
        this.activeTemperature = 'cold'; 
      }
    }
  },

  computed: {
    isHotActive() { return this.activeTemperature === 'hot' },
    isWarmActive() { return this.activeTemperature === 'warm' },
    isColdActive() { return this.activeTemperature === 'cold' }
  },

  methods: {
    async saveTemperature() {
      try {
        await axios.put(
          `/deal/${this.dealId}/temperature`,
          {
            temperature: this.activeTemperature
          },
          { 
            headers: { 
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            } 
          }
        );
        this.$emit('temperature-saved', this.activeTemperature);
        Bus.$emit('temperature-saved');
        this.hide();
        Alert.success(this.__('Salvo com sucesso!'));
      } catch (error) {
        Alert.error(this.__('Erro ao salvar.'));
      }
    },

    show() {
      this.$refs.modal.show()
    },

    hide() {
      this.$refs.modal.hide()
    },

    toggleTemperature(temp) {
      this.activeTemperature = this.activeTemperature === temp ? null : temp
    }
  }
}
</script>

<style lang="scss">
.modal-temperature {
  .title {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #71767D;
    margin-bottom: 32px;
    display: block;
    text-align: center;
    margin-top: 19px;
  }

  .modal-dialog {
    width: 298px;
    height: 351px;
  }

  .modal-content {
    border:none;
  }

  .modal-content .modal-body {
    padding: 24px;
  }

  .buttons-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .salesflow-btn {
        width: 100px;
        height: 44px;
        border-radius: 12px;
        padding: 8px 24px;
        margin-top: 16px;
    }
  }

  .close {
    opacity: 1 !important;
    
    &:hover, &:focus {
      opacity: 1 !important;
    }
  }
}

// Remover padding duplicado ou sobreposto
.modal-temperature .modal-body {
  padding: 24px !important;  // Força o padding correto
}

// Classe base para todos os botões de temperatura
.button-temperature {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 11px 14px;
  border-radius: 8px;
  width: 250px;
  height: 40px;
  background: #F4F1FF;
  border: none;

  &:hover {
    text-decoration: none;
  }

  .label-temperature {
    margin: 0;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
    line-height: 18px;
    color: #71767D;
  }
}

// Variações específicas para cada temperatura
.button-hot-modal {
  @extend .button-temperature;

  &:hover:not(.active) {
    background-color: #FFD9D9;
    
    img {
      content: url('/build/icons/hot-icon-gray.svg');
      filter: brightness(0) saturate(100%) invert(45%) sepia(95%) saturate(1623%) hue-rotate(346deg) brightness(101%) contrast(101%);
    }

    .label-hot-modal {
      color: #FF611E;
    }
  }

  &.active {
    background-color: #FFD9D9;
    border: 1px solid #FD5050;

    img {
      content: url('/build/icons/hot-icon.svg');
    }

    .label-hot-modal {
      color: #FF3B30;
    }
  }
}

.button-warm-modal {
  @extend .button-temperature;

  &:hover:not(.active) {
    background-color: #FFECCF;
    
    img {
      content: url('/build/icons/warm-icon-gray.svg');
      filter: brightness(0) saturate(100%) invert(55%) sepia(86%) saturate(1867%) hue-rotate(360deg) brightness(103%) contrast(106%);
    }

    .label-warm-modal {
      color: #FF9900;
    }
  }

  &.active {
    background-color: #FFECCF;
    border: 1px solid #FF9900;
    
    img {
      content: url('/build/icons/warm-icon-gray.svg');
      filter: brightness(0) saturate(100%) invert(55%) sepia(86%) saturate(1867%) hue-rotate(360deg) brightness(103%) contrast(106%);
    }

    .label-warm-modal {
      color: #FF9900;
    }
  }
}

.button-cold-modal {
  @extend .button-temperature;

  &:hover, &.active {
    background-color: #E5F1FF;
    
    img {
      content: url('/build/icons/cold-icon.svg');
    }

    .label-cold-modal {
      color: #0C81ED;
    }
  }

  &.active {
    border: 1px solid #4B99E1;
  }
}

.modal-no-header-no-footer .close {
    top: 10px;
    right: 25px;
    opacity: unset;
}
</style>
